import React, {useState} from "react";
import S from './Program.module.scss';
import arrowDown from '../../shared/assets/images/arrow-down-svgrepo-com.svg';
import arrowUp from '../../shared/assets/images/arrow-up-svgrepo-com.svg';

interface ProgramProps {
    event?: any;
}

export const ProgramPanelTree = ({event}: ProgramProps) => {
    const [isOnePanelOpen, setIsOnePanelOpen] = useState(false);
    const [isSecondPanelOpen, setIsSecondPanelOpen] = useState(false);
    const [isThreePanelOpen, setIsThreePanelOpen] = useState(false);
    const [isFourPanelOpen, setIsFourPanelOpen] = useState(false);
    return (
        <>
            {event === 1 ? (
                <div className={S.panelStyle}>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ ДЕМИДОВ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> КАЧЕСТВО И КОНТРОЛЬ В ПОТОКЕ.</div>
                            <div className={`${S.paragraphDivWrapper} ${isOnePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>КОМПЬЮТЕРНОЕ ЗРЕНИЕ И КОНТРОЛЬ ДЕФЕКТОВ: 99,2%
                                        АВТОМАТИЧЕСКОЙ РАЗБРАКОВКИ ТРУБЫ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>БЕСКОНТАКТНЫЙ КОНТРОЛЬ КАЧЕСТВА В ПОТОКЕ:
                                        ОПТИЧЕСКИЕ ИЗМЕРИТЕЛЬНЫЕ СИСТЕМЫ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРОСЛЕЖИВАЕМОСТЬ ПРОДУКЦИИ: ЦИФРОВОЙ ПАСПОРТ
                                        ИЗДЕЛИЯ ОТ ПЛАВКИ ДО ОТГРУЗКИ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsOnePanelOpen(!isOnePanelOpen)}
                                className={S.button}
                            >
                                {isOnePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isOnePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ ДЕМИДОВ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> ЦЕХ, ЛОГИСТИКА И ОТРАСЛЕВЫЕ РЕШЕНИЯ.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isSecondPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>МОБИЛЬНЫЕ РЕШЕНИЯ ДЛЯ ЦЕХА: ОБХОДЫ, НАРЯДЫ,
                                        ГОЛОСОВЫЕ АССИСТЕНТЫ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭЛЕКТРОННЫЙ ДОКУМЕНТООБОРОТ И ТЕХНИЧЕСКАЯ
                                        ДОКУМЕНТАЦИЯ: EDMS ВМЕСТО БУМАЖНЫХ ЦЕХОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СКЛАДЫ И ВНУТРИЦЕХОВАЯ ЛОГИСТИКА: WMS НА
                                        ПРОИЗВОДСТВЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ДИСПЕТЧЕРИЗАЦИЯ И ЦИФРОВАЯ ЛОГИСТИКА: КАРЬЕРНАЯ
                                        ТЕХНИКА, МУЛЬТИМОДАЛЬНЫЕ ПЕРЕВОЗКИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВИЗАЦИЯ НЕДРОПОЛЬЗОВАНИЯ: ГЕОЛОГИЯ, КЕРН И
                                        МАРКШЕЙДЕРСКИЕ ДАННЫЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ОПТИМИЗАЦИЯ ОБОГАТИТЕЛЬНЫХ ФАБРИК: +1,3 П.П.
                                        ИЗВЛЕЧЕНИЯ ЗОЛОТА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРОМЫШЛЕННАЯ РОБОТОТЕХНИКА: РОССИЙСКИЕ РТК ВМЕСТО
                                        FANUC И KUKA
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПРОМЫШЛЕННАЯ БЕЗОПАСНОСТЬ: КОНТРОЛЬ ОПАСНЫХ ЗОН,
                                        ОХРАНА ТРУДА, ПРЕДИКТИВ АВАРИЙ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВОЕ ПРОЕКТИРОВАНИЕ И АВТОКОНТРОЛЬ ДЕТАЛЕЙ:
                                        ОПЫТ АВИА- И МАШИНОСТРОЕНИЯ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsSecondPanelOpen(!isSecondPanelOpen)}
                                className={S.button}
                            >
                                {isSecondPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isSecondPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel}>ЗАЛ НОБЕЛЬ</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>СЕССИЯ.</span> ЗНАНИЯ И ЦИФРОВАЯ ТРАНСФОРМАЦИЯ.</div>
                            <div className={`${S.paragraphDivWrapper} ${isThreePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ТЕХРЕГЛАМЕНТЫ И КИП-ДАННЫЕ: ЕДИНЫЙ КОНТУР
                                        ИНЖЕНЕРНЫХ ЗНАНИЙ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ОЦИФРОВКА ЭКСПЕРТНЫХ ЗНАНИЙ: ОТ НАСТАВНИКОВ К БАЗЕ
                                        ЗНАНИЙ ПРЕДПРИЯТИЯ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>КУЛЬТУРА ЦИФРОВОЙ ТРАНСФОРМАЦИИ: СТРАТЕГИЯ 2030 И
                                        ВОВЛЕЧЕНИЕ КОЛЛЕКТИВА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>WORKFORCE 2.0: ПРИВЛЕЧЕНИЕ И УДЕРЖАНИЕ МОЛОДЁЖИ В
                                        ПРОМЫШЛЕННОСТИ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>КАДРЫ ДЛЯ ЦИФРОВОГО ЗАВОДА: КАК ОБУЧИТЬ РАБОЧИХ И
                                        ИТР НОВЫМ ИНСТРУМЕНТАМ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>КОММЕРЦИАЛИЗАЦИЯ ЦИФРОВЫХ ПРОДУКТОВ И ЭКСПОРТ
                                        ПРОМЫШЛЕННОГО ПО: КЕЙСЫ СНГ И БЛИЖНЕГО ВОСТОКА
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsThreePanelOpen(!isThreePanelOpen)}
                                className={S.button}
                            >
                                {isThreePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isThreePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraph}/>
                        <div className={S.hallPanel} />
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanel}><span>ДЕМОДЕНЬ ИНДУСТРИАЛЬНОГО ЦЕНТРА КОМПЕТЕНЦИЙ (ИЦК) «МЕТАЛЛУРГИЯ».</span></div>
                            <div className={`${S.paragraphDivWrapper} ${isFourPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}/>
                                <div className={S.titlePanel}><span>КРУГЛЫЙ СТОЛ.</span> «ЦИФРОВИЗАЦИЯ ЛОГИСТИКИ И
                                    РЕСУРСНЫХ АКТИВОВ: ИИ-ДИСПЕТЧЕР, ОПТИМИЗАЦИЯ ПЕРЕВОЗОК И ОБОГАЩЕНИЯ»
                                </div>
                                <div className={S.titlePanel}><span>КРУГЛЫЙ СТОЛ.</span> «ОЦИФРОВКА ЗНАНИЙ И КУЛЬТУРА
                                    ЦИФРОВОЙ ТРАНСФОРМАЦИИ: КАК СОХРАНИТЬ ЭКСПЕРТИЗУ И ОБУЧИТЬ 50 000 СОТРУДНИКОВ»
                                </div>
                                <div className={S.titlePanel}><span>ЗАКРЫТЫЙ КРУГЛЫЙ СТОЛ CDO/CIO.</span> «ПРОМЫШЛЕННЫЙ
                                    ИИ-2030: СТРАТЕГИЧЕСКИЕ ПРИОРИТЕТЫ ЛИДЕРОВ»
                                </div>
                            </div>
                            <div
                                onClick={() => setIsFourPanelOpen(!isFourPanelOpen)}
                                className={S.button}
                            >
                            {isFourPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isFourPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={S.panelStyle}>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 1</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> ЦИФРОВИЗАЦИЯ, ИИ И БЕСПИЛОТНЫЕ
                                ТЕХНОЛОГИИ.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isOnePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ИИ В ПЛАНИРОВАНИИ ТРАНСПОРТА: ПОДСКАЗКИ, ВЫБОР
                                        ПРИОРИТЕТОВ, ОПТИМИЗАЦИЯ МАРШРУТОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>БЕСПИЛОТНЫЕ СИСТЕМЫ В ПРОМЫШЛЕННОСТИ: ТЕЛЕЖКИ,
                                        МАШИНЫ, ИНФРАСТРУКТУРА — ТЕКУЩАЯ ЗРЕЛОСТЬ И ДОРОЖНАЯ КАРТА
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЦИФРОВИЗАЦИЯ ДИСПЕТЧЕРИЗАЦИИ И ЭКСПЛУАТАЦИИ: АВТО,
                                        Ж/Д, КАРЬЕРНЫЙ ТРАНСПОРТ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СИСТЕМЫ БЕЗОПАСНОСТИ НА ТРАНСПОРТЕ: УСТРОЙСТВА И
                                        МЕХАНИЗМЫ НА ПОГРУЗЧИКАХ, ЭКСКАВАТОРАХ, АВТО
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsOnePanelOpen(!isOnePanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isOnePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isOnePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 1</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> БЕЗОПАСНОСТЬ ПРОИЗВОДСТВА И
                                ОХРАНА ТРУДА.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isSecondPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>БЕЗОПАСНОСТЬ РЕМОНТНЫХ РАБОТ В РЕМОНТНЫХ ЗОНАХ:
                                        ИНСТРУМЕНТЫ И ПОДХОДЫ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ПОВЫШЕНИЕ БЕЗОПАСНОСТИ ДВИЖЕНИЯ: НА КАКИХ МАШИНАХ
                                        УСТАНОВЛЕНЫ СИСТЕМЫ, КАКИЕ УСТРОЙСТВА РАБОТАЮТ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>РАБОТА В ЭКСТРЕМАЛЬНЫХ УСЛОВИЯХ: КАРЬЕРЫ В ТУМАН,
                                        ГОЛОЛЁД, СНЕГОПАД — МЕРОПРИЯТИЯ И ЭНЕРГОЭФФЕКТИВНОСТЬ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>СНЕГОБОРЬБА: ОРГАНИЗАЦИЯ РАБОТ, ТЕХНИКА, МЕТОДИКИ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsSecondPanelOpen(!isSecondPanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isSecondPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isSecondPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 2</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>СЕССИЯ.</span> АЛЬТЕРНАТИВНАЯ ЭНЕРГЕТИКА, НОВЫЕ
                                ТОПЛИВА И КАДРЫ.
                            </div>
                            <div className={`${S.paragraphDivWrapper} ${isThreePanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>АЛЬТЕРНАТИВНЫЕ ИСТОЧНИКИ ЭНЕРГИИ И ТОПЛИВО:
                                        ВОДОРОД, НАРАБОТКИ, ПРИМЕНИМОСТЬ НА ТРАНСПОРТЕ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ЭНЕРГОЭФФЕКТИВНОСТЬ ТРАНСПОРТА: КАРЬЕРНЫЙ, Ж/Д,
                                        АВТОПАРК
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ОБУЧЕНИЕ, ПОДГОТОВКА И УДЕРЖАНИЕ ПЕРСОНАЛА: СИСТЕМА
                                        МОТИВАЦИИ ТРАНСПОРТНИКОВ, ДЕФИЦИТ КАДРОВ
                                    </div>
                                </div>
                                <div className={S.paragraphTextDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.paragraphText}>ОПЫТ СМЕЖНЫХ ОТРАСЛЕЙ: ПОРТ, НЕФТЕГАЗ, РИТЕЙЛ, FMCG
                                        — ЧТО МОЖНО ВЗЯТЬ НА ВООРУЖЕНИЕ
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => setIsThreePanelOpen(!isThreePanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isThreePanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isThreePanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={S.titlePanelDiv}>
                        <div className={S.paragraphLogistics}/>
                        <div className={S.hallPanel}>ЗАЛ 2</div>
                        <div className={S.paragraphPanel}>
                            <div className={S.titlePanelLogistics}><span>ДИСКУССИОННАЯ СЕССИЯ.</span></div>
                            <div className={`${S.paragraphDivWrapper} ${isFourPanelOpen ? S.open : S.closed}`}>
                                <div className={S.paragraphTextTitle}>ТЕМЫ:</div>
                            </div>
                            <div
                                onClick={() => setIsFourPanelOpen(!isFourPanelOpen)}
                                className={S.buttonLogistics}
                            >
                                {isFourPanelOpen ? "СВЕРНУТЬ" : "РАЗВЕРНУТЬ"}
                                <div>
                                    {isFourPanelOpen ? (
                                        <img src={arrowUp} alt="arrowUp"/>
                                    ) : (
                                        <img src={arrowDown} alt="arrowDown"/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};